import * as React from 'react';

import { FormSelectField, SelectFieldProps } from 'ui';
import { PhoneCountryCodeOptions } from '@tock/shared/constants/PhoneCountryCodeOptions';

export interface FormPhoneCountryCodeFieldProps
  extends Pick<SelectFieldProps, Exclude<keyof SelectFieldProps, 'children'>> {
  phoneFieldName?: string;
  children?: React.ReactNode;
}

const FormPhoneCountryCodeField = ({
  name = 'phoneCountryCode',
  id = 'phoneCountryCode',
  phoneFieldName = 'phone',
  fullWidth,
  className,
  label = 'Phone country code',
  onChange,
  helperText,
  ...rest
}: FormPhoneCountryCodeFieldProps) => {
  return (
    <FormSelectField
      fullWidth={fullWidth}
      name={name}
      id={id}
      label={label}
      onChange={onChange}
      SelectProps={{
        inputProps: {
          'data-testid': 'phone-country-code',
          autoComplete: 'tel-country-code',
        },
      }}
      {...rest}
    >
      <option value="" />
      <PhoneCountryCodeOptions />
    </FormSelectField>
  );
};

export default FormPhoneCountryCodeField;
